import React, { useState, useEffect } from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";
import useTitle from "../components/Title";
import UserGroupSearch from "../components/SearchFunctionality";
import UserJoinedGroups from "../components/UserJoinedGroups";
import { Link } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const Groups = () => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });

    return () => unsubscribe();
  }, []);

  useTitle("- Groups ");

    const handleSelectUser = (user) => {
    // console.log("Selected user:", user);
    // TODO: Add your logic here - navigate to user profile, open chat, etc.
  };

  const handleSelectGroup = (group) => {
    // console.log("Selected group:", group);
    // TODO: Add your logic here - navigate to group page, etc.
  };
    
  return (
    <div className="">
      <Navbar />
      <div className="App-header mt-4">
        <div className="container-md">

          <div className="row justify-content-between align-items-center ">
            <div className="col-md-10 col-sm-12">
                <h1 className="mt-5 event-heading-start">Groups.</h1>
                <p className="event-sub-text mb-3"> This is where user groups will be managed.  </p>
            </div>


            {currentUser && (
              <div className="col-md-2 col-sm-12 text-md-end"><Link to="/CreateGroup" className="btn btn-primary">Create Group</Link></div>
            )}
          </div>


          <div className="row my-5 py-5 w-100">
            <div className="col-12">
              <div className="d-flex justify-content-center">
                <div className="w-100">
                  <UserGroupSearch onSelectUser={handleSelectUser} onSelectGroup={handleSelectGroup} />
                </div>
              </div>
            </div>
          </div>

  
         <UserJoinedGroups />


        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Groups;
